import React from "react"
import '../assets/styles/loader.css'
import logo from "../assets/images/logo.svg"

function Loader () {
    return (
        <div className="loader">
            <img className="logo_loader" src={logo} />
        </div>
    )
}

export default Loader

{/* <div className='overlay'>
    <div className="blobs">
        <div className="blob-center"></div>
        <div className="blob"></div>
        <div className="blob"></div>
        <div className="blob"></div>
        <div className="blob"></div>
        <div className="blob"></div>
        <div className="blob"></div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
        <defs>
            <filter id="goo">
                <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"/>
                <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                                result="goo"/>
                <feBlend in="SourceGraphic" in2="goo"/>
            </filter>
        </defs>
    </svg>
    <h1>Loading...</h1>
</div> */}